import { render, staticRenderFns } from "./EmergencyContacts.vue?vue&type=template&id=f55322dc&scoped=true"
import script from "./EmergencyContacts.vue?vue&type=script&lang=js"
export * from "./EmergencyContacts.vue?vue&type=script&lang=js"
import style0 from "./EmergencyContacts.vue?vue&type=style&index=0&id=f55322dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55322dc",
  null
  
)

export default component.exports